<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <div class="flex-grow-1">
                    <router-link :to="'/history/' + movixId" class="mr-3">
                        <icon name="chevron-left"/> Back
                    </router-link>
                    <strong>{{ movieTitle }}</strong>
                    <span class="text-muted ml-2">— Admissions per month</span>
                </div>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No admissions data found.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th class="shx-th-120">Month</th>
                            <th class="shx-th-120 text-right">Admissions</th>
                            <th class="shx-th-200">Drill down</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.month">
                            <td>{{ row.month }}</td>
                            <td class="text-right">{{ formatInt(row.admissions) }}</td>
                            <td>
                                <router-link :to="'/history/' + movixId + '/month/' + row.month + '/day'"
                                             class="btn btn-sm btn-outline-secondary mr-2">
                                    Per Day
                                </router-link>
                                <router-link :to="'/history/' + movixId + '/month/' + row.month + '/site'"
                                             class="btn btn-sm btn-outline-secondary">
                                    Per Cinema
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>Total</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissions) }}</strong></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['movixId'],
    data() {
        return {
            loading: true,
            rows: [],
        };
    },
    computed: {
        movieTitle() {
            const current = this.$store.getters.historyCurrent;
            return (current && current.movix_title) ? current.movix_title : `Movix #${this.movixId}`;
        },
        totalAdmissions() {
            return this.rows.reduce((sum, r) => sum + (r.admissions || 0), 0);
        },
    },
    created() {
        this.ensureMovieLoaded();
        this.loadMonths();
    },
    methods: {
        ensureMovieLoaded() {
            const current = this.$store.getters.historyCurrent;
            if (!current || String(current.movix_id) !== String(this.movixId)) {
                this.$store.dispatch('fetchHistory', this.movixId).catch(() => {});
            }
        },
        loadMonths() {
            this.loading = true;
            axios
                .get(`/history/${this.movixId}/month`)
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
    },
};
</script>
